import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { CommonApiService } from "src/app/services/common-api.service";
import { EditActions } from "./edit.index";
import { catchError, map, of, switchMap } from "rxjs";
import { API } from "src/app/common/models/api.enum";
import { CreateAiAgent } from "src/app/common/models/ai-agents.model";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";
import { AlertService } from "src/app/services/alert.service";

@Injectable()
export class EditAiAgentEffects {
  actions = inject(Actions);
  commonApiService = inject(CommonApiService);
  readonly commonStore = inject(CommonSignalStore);
  alertService = inject(AlertService);

  editAiAgent$ = createEffect(() => {
    return this.actions.pipe(
      ofType(EditActions.editAiAgent),
      switchMap((actions) => {
        const userId = this.commonStore.loginData()?.data?.userId;
        if (!userId) {
          return of(
            EditActions.editAiAgentError({ error: "User Id is required" }),
          );
        }

        let fullURL = API.EDIT_AI_AGENTS.replace(
          "{{ userId }}",
          userId,
        ).replace("{{ agentId }}", actions.agentId);

        return this.commonApiService
          .put<CreateAiAgent>(fullURL, actions.payload)
          .pipe(
            map((response) =>
              EditActions.editAiAgentSuccess({
                response,
                action: actions.action,
                languageName: actions.languageName,
              }),
            ),
            catchError(({ error }) => {
              this.alertService.alertDanger("Failed", error.error || "");
              return of(EditActions.editAiAgentError({ error }));
            }),
          );
      }),
    );
  });
}
